/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';
import Modal from '../Modal';
import { raiseToast } from '../Toast';

import {
  ModalContent,
  Icon,
  StyledCheck,
  Bold,
} from './ReleaseGradesButton.styled';

const ReleaseGradesButton = ({
  handleReleaseGrades,
  isGradesReleased,
  currentGrades,
  totalGrades,
  disabled,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleAccept = async () => {
    setIsModalOpen(false);

    try {
      await handleReleaseGrades();

      raiseToast({ message: 'Grades released!' });
    } catch (e) {
      raiseToast({ message: 'Oops! Something went wrong.', type: 'fail' });
    }
  };

  if (isGradesReleased) {
    return (
      <Button disabled look="secondary" label="disabled release grades button">
        Grades released
        <StyledCheck />
      </Button>
    );
  }

  return (
    <>
      <Button
        onClick={handleOpenModal}
        look="outlinePrimary"
        disabled={disabled}
        label="release grades button"
      >
        Release Grades
        <Icon role="img" aria-label="congrats">
          🎉
        </Icon>
      </Button>
      <Modal
        open={isModalOpen}
        handleClose={handleCloseModal}
        handleSubmit={handleAccept}
        headerText="Release grades"
        submitText="Release"
      >
        <ModalContent>
          You are about to release
          <Bold>{`${currentGrades} / ${totalGrades} grades`}</Bold>
          to your students. Would you like to continue?
        </ModalContent>
      </Modal>
    </>
  );
};

ReleaseGradesButton.propTypes = {
  isGradesReleased: PropTypes.bool.isRequired,
  handleReleaseGrades: PropTypes.func.isRequired,
  currentGrades: PropTypes.string.isRequired,
  totalGrades: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

ReleaseGradesButton.defaultProps = {
  disabled: false,
};

export default ReleaseGradesButton;
